exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pagination__actions__container {\n  flex-shrink: 0 !important;\n  margin-left: 25px;\n  margin-right: 32px; }\n\n.pagination__actions__icon {\n  color: #ff8c8c !important; }\n\n.pagination__actions__icon:disabled {\n  color: grey !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Utility/PaginationActions/index.scss
// module id = 1087
// module chunks = 1